import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { LanguageContext } from '../Context';

// custom hook for default component name setting.
const useGetComponentName = (ind) =>
{
	const { language } = useContext(LanguageContext);
	const originaName =
{
	1  : language?.newsFeed,
	2  : language?.collaboration,
	3  : language?.resources,
	4  : language?.certifications,
	5  : language?.tasks,
	6  : language?.networks,
	7  : language?.mediaDrive,
	8  : language?.meetings,
	9  : language?.webinar,
	10 : language?.affiliate,
	11 : language?.dealRegistration,
	12 : language?.businessProspects,
	13 : language?.productWarranty,
	14 : language?.contracts
};

	const selectedIndMenuData = useSelector((state:any) =>
		state?.mysession?.sideMenuData?.find((item) => item?.index === ind));

	return selectedIndMenuData && !selectedIndMenuData?.isOriginalName
		? selectedIndMenuData?.name || ''
		: originaName[ind] || '';
};

export default useGetComponentName;